import Flickity from 'flickity';
// import TapListener from 'tap-listener';
// import tracking from 'tracking';
import { debounce } from 'lodash/function';

const defaults = {
  cellSelector: '.carousel__item',
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  setGallerySize: true,
  groupCells: true,
  minSlides: 2,
  arrowShape: {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 75,
    y2: 35,
    x3: 40
  },
  enabledClass: 'carousel--enabled',
  destroyedClass: 'carousel--destroyed',
  arrowClass: '.flickity-prev-next-button',
  dotClass: '.dot'
};

class Carousel {

  constructor (element, settings) {
    this.element = element;
    this.options = Object.assign({}, defaults, settings);
    this.resizeListener = this.resizeEvent.bind(this);
    this.focusListener = this.focusEvent.bind(this);
    this.selectedIndex = 0;
    this.debouncedResize = debounce(this.resizeListener, 75, {
      leading: true,
      trailing: true
    });
  }

  removeFocusAccessibility () {
    const sliderLinks = this.element.querySelectorAll('a');
    [...sliderLinks].forEach(linkItem => {
      delete linkItem.cellIndex;
      linkItem.removeEventListener('focus', this.focusListener, false);
    });
  }

  fixFocusAccessibility () {
    // This makes sure that links focussed inside the slider using keyboard
    // trigger a selection on the carousel, as on focus they are shown in view.
    [...this.carousel.cells].forEach((cellItem, cellIndex) => {
      const cellLinks = cellItem.element.querySelectorAll('a');
      [...cellLinks].forEach(linkItem => {
        linkItem.cellIndex = cellIndex;
        linkItem.addEventListener('focus', this.focusListener, false);
      });
    });
  }

  focusEvent (e) {
    this.carousel.selectCell(e.target.cellIndex, true);
  }

  resizeEvent () {
    this.element.classList.toggle('is-resizing');
  }

  removeEventListeners () {
    window.removeEventListener('resize', this.debouncedResize, false);
    this.removeFocusAccessibility();
  }

  addEventListeners () {
    window.addEventListener('resize', this.debouncedResize, false);
    this.fixFocusAccessibility();
  }

  selectElement (element) {
    element.setAttribute('aria-hidden', false);
  }

  deselectElement (element) {
    element.setAttribute('aria-hidden', true);
  }

  removeSelectEvent () {
    [...this.carousel.cells].forEach(item => item.element.removeAttribute('aria-hidden'));
  }

  toggleAccessibilityAttrs () {
    [...this.carousel.cells]
      .forEach(item => this.deselectElement(item.element));
    [...this.carousel.selectedElements]
      .forEach(item => this.selectElement(item));
  }

  addSelectEvent () {
    this.carousel.on('select', () => {
      // Toggle ARIA attrs for accessibility
      this.toggleAccessibilityAttrs();
      // Set slide index value
      this.selectedIndex = this.carousel.selectedIndex;
    });
  }

  destroy () {
    this.carousel.destroy();
    this.element.parentNode.classList.remove(this.options.enabledClass);
    this.element.parentNode.classList.add(this.options.destroyedClass);
    this.removeEventListeners();
    this.removeSelectEvent();
  }

  getCarousel () {
    return this.carousel;
  }

  galleryTracking () {
    const buttons = this.element.querySelectorAll(this.options.dotClass);
    const arrows = this.element.querySelectorAll(this.options.arrowClass);
    const clickItems = [...arrows, ...buttons];
    // const trackingParams = this.element.parentNode;
    if (clickItems && clickItems.length) {
      clickItems.forEach(function (item) {
      /* const tapper = new TapListener(item);
        tapper.on('tap', function () {
          tracking.trackingEvent('carouselSelect', tracking.getTrackingParams(trackingParams));
        }); */
      });
    }
  }

  init () {
    this.carousel = new Flickity(this.element, this.options);

    if (this.carousel.cells.length >= this.options.minSlides) {
      this.element.parentNode.classList.remove(this.options.destroyedClass);
      this.element.parentNode.classList.add(this.options.enabledClass);
      this.addEventListeners();
      this.addSelectEvent();
      this.galleryTracking();
      setTimeout(() => this.carousel.resize(), 50);
    } else {
      this.destroy();
    }
  }
}

export default Carousel;
